import type { CSSProperties } from "react";

export const COURSE_TEMPLATE_PLACEHOLDER_KEYS =
  "character|level|levelRules|userOriginLanguage|userTargetLanguage|user_tasks|ai_tasks|topic|context";

export const COURSE_TEMPLATE_PLACEHOLDERS_TEXT =
  "{{character}}, {{level}}, {{levelRules}}, {{userOriginLanguage}}, {{userTargetLanguage}}, {{user_tasks}}, {{ai_tasks}}, {{topic}}, {{context}}";

export const COURSE_TEMPLATE_LANGUAGE_PREVIEW_KEYS = new Set([
  "userOriginLanguage",
  "userTargetLanguage",
]);

export const COURSE_TEMPLATE_PLACEHOLDERS_HINT_STYLE: CSSProperties = {
  marginBottom: 8,
  fontSize: 12,
  color: "rgba(0, 0, 0, 0.55)",
  lineHeight: 1.45,
};
